module.exports = __webpack_public_path__ + "static/img/avatar_11.0741379.png";


//////////////////
// WEBPACK FOOTER
// ./static/avatars/avatar_11.png
// module id = 1591
// module chunks = 61